import React, { FC, PropsWithChildren } from 'react';
import { TUseSetUserStatusData, useGetUserStatus } from '../hooks';

export interface IRenderBasedOnUserStatusProps extends PropsWithChildren {
  allowedStatuses?: TUseSetUserStatusData['status'][];
}

export const RenderBasedOnUserStatus: FC<IRenderBasedOnUserStatusProps> = ({
  allowedStatuses = ['VERIFIED'],
  children,
}) => {
  const userStatusData = useGetUserStatus();

  if (allowedStatuses.includes(userStatusData?.status)) {
    return <>{children}</>;
  }

  return null;
};
